import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef } from "react";
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";

import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';

import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';

import FormTextArea from './../inputs/textarea';

import FormSelect from './../inputs/select';
import FormDate from './../inputs/date';

import FormSwitch from './../inputs/switch';
import FormFileUpload from "./../inputs/fileupload";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { prepareForm, getValueFromForm, getUserTypes, getLanguages, currentUserId, twoDecimalFormatter, getLocalizedCountryFromCurrency } from './../../utils';
import FormAutoComplete from './../inputs/autocomplete';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import InputMask from "react-input-mask";
import { toJS } from "mobx";

const UsersEdit = () => {

    let navigate = useNavigate();
    const { state } = useLocation();
    
    const { usersAdminStore, activitiesStore, companiesStore, utilsStore } = useStores();
    const { getById, user, reset, save, getProfile, updateProfile } = usersAdminStore;
    const { getCurrencies, currencies } = utilsStore;
    //const { get, activity, reset } = activitiesStore;
    const { searchCompany } = companiesStore;
    const { t, i18n } = useTranslation();    
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);   
    const [validated, setValidated] = useState(false);
    const messageForm = useRef(null);
    const isNew = () => id && id == "new";

    const [salary, setSalary] = useState(false);
    const [type, setType] = useState(null);
    const isProfile = state?.isProfile ?? false;
    const [telephoneIT, setTelephoneIT] = useState(false);
    const [expenseEnabled, setExpenseEnabled] = useState({});

    useEffect(() => {
        setIsLoading(true);

        Promise.all(id == "new" ? [getCurrencies()] : [(isProfile ? getProfile() : getById(id, () => {goToList()})), getCurrencies()]).then(() => {
            setIsLoading(false)
        });

        if (id === "new") { handleReset(); } 

    }, [getById,reset,id]);


    useEffect(() => {        
        setExpenseEnabled(user.currenciesExpenseCosts?.reduce((obj, item) => (obj[`expenseCosts_${item.currencyId}`] = true, obj), {}))
    }, [user]);
    
    const handleReset = () => {
        reset();        
        setValidated(false);
    };

    const goToList = () => {
        navigate(isProfile?"/":"/administration/users")
    };

    const getExpensEnabled = (id) => {
        return user?.currenciesExpenseCosts?.find(x => x.currencyId == id)?.enabled ?? false;
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {           
            var formData = prepareForm(event, isNew(), ["id", "type", "telephoneITDefault"], ["telephoneITDefault"]);            

            formData.currenciesExpenseCosts = Object.keys(formData).filter(e => e.indexOf("expenseCosts_") > -1).map(x => { var obj = formData[x]; return { currencyId: Number(x.split("_")[1]), enabled: obj } });
            Object.keys(formData).forEach((e, idx) => {
                if (e.indexOf("expenseCosts_") > -1) {
                    delete formData[e];
                }
            });

            /*console.log(formData)
            return;*/

            if (isProfile) {
                updateProfile(formData, () => {
                    i18n.changeLanguage(formData?.language ?? "fr");
                    goToList();
                });
            }
            else {                
                save(formData, () => { goToList(); });
            }
        }

        setValidated(true);
    };

    const isDevOrProfile = isProfile || type == 3;
    return (       

        <Form noValidate validated={validated} onSubmit={handleSubmit} ref={messageForm}>
            <Card>
               
                <Card.Body>
                    <div>                      
                        <Stack direction="vertical">
                            
                            <Row>                                
                                <Col style={{ alignSelf: "center" }}>
                                    <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate(isProfile?"/":"../users")} size="small" />
                                    {isProfile ? <b>{t("profile")}</b>: <b>{t(isNew() ? 'newUser' : 'user')} {!isNew() && `(Id: ${id})`}</b>}
                                </Col>
                                <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>
                                <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                            </Row>

                            <hr />
                            {isProfile && <span>
                                <Row className="my-2">                                                                        
                                    <Col xs={2}>
                                        <FormText hidden isNumber id="id" type="number" object={user} />
                                        <FormSelect required label={t("language")} id="language" isLoading={isLoading} itemId="id" itemLabel="name" items={getLanguages()} object={user} />
                                    </Col>

                                    <Col xs={2}>
                                        <FormText label={t("mobile")} id="mobilePhone" isLoading={isLoading} object={user} />
                                    </Col>

                                    <Col xs={2}>
                                        <FormText label={t("landline")} id="landlinePhone" isLoading={isLoading} object={user} />
                                    </Col>

                                    <Col xs={2}>
                                        <FormText required label={t("email")} id="email" isLoading={isLoading} object={user} />
                                    </Col>                                    
                                </Row>

                                <Row className="my-2">
                                <Col xs={2}>
                                    <FormText lines={3} label={t("address")} id="address" isLoading={isLoading} object={user} />
                                    </Col>
                                </Row>

                            </span>}
                            {!isProfile && <span>
                                {/*Start First Block*/}
                                <Row className="my-2">
                                    <Col xs={2}>
                                        <FormSwitch label={t("active")} title="" id="isActive" isLoading={isLoading} object={user} valueIfNull={true} />
                                    </Col>
                                </Row>
                                <Row className="my-2">
                                    <Col xs={2}>
                                        <FormText hidden isNumber id="id" type="number" object={user} />
                                        <FormText required label={t("username")} id="username" isLoading={isLoading} object={user} />
                                    </Col>

                                    <Col xs={2}>
                                        <FormText required type="password" label={t("password")} id="password" isLoading={isLoading} object={user} />
                                    </Col>

                                    <Col xs={2}>
                                        <FormSelect required disabled={id !== "new"} label={t("type")} id="type" observe={(v) => setType(v)} isLoading={isLoading} itemId="id" itemLabel="name" items={getUserTypes()} object={user} />
                                    </Col>

                                    <Col xs={2}>
                                        <FormSelect required label={t("language")} id="language" isLoading={isLoading} itemId="id" itemLabel="name" items={getLanguages()} object={user} />
                                    </Col>

                                    
                                </Row>

                                <Row className="my-2">
                                    <Col xs={3}>
                                        <FormText required label={t("name")} id="name" isLoading={isLoading} object={user} />
                                    </Col>

                                    <Col xs={3}>
                                        <FormText required label={t("surname")} id="surname" isLoading={isLoading} object={user} />
                                    </Col>

                                    <Col xs={2}>
                                        <FormText required type="email" recentlyChanged={user?.recentChanges?.includes("Email")}  label={t("email")} id="email" isLoading={isLoading} object={user} />
                                    </Col>
                                </Row>

                                {type == 3 && <Row className="my-2">
                                    <Col xs={2}>
                                        <FormText label={t("mobile")} recentlyChanged={user?.recentChanges?.includes("Mobile")} id="mobilePhone" isLoading={isLoading} object={user} />
                                    </Col>
                                    <Col xs={2}>
                                        <FormText label={t("landline")} recentlyChanged={user?.recentChanges?.includes("Landline")} id="landlinePhone" isLoading={isLoading} object={user} />
                                    </Col>
                                    <Col xs={2}>
                                        <FormText lines={3} label={t("address")} recentlyChanged={user?.recentChanges?.includes("Address")}  id="address" isLoading={isLoading} object={user} />
                                    </Col>
                                    <Col xs={2}>
                                        <FormText lines={5} label={t("information")} id="information" isLoading={isLoading} object={user} />
                                    </Col>
                                </Row>}

                                {/*End First Block*/}
                            </span>}

                            {isDevOrProfile && <hr />}
                            
                            {isDevOrProfile && <Row className="my-2">
                                <Col xs={8}>
                                    {isLoading ? <Skeleton width={100} /> : <span>{t("contactInformation")}:</span>}
                                </Col>
                            </Row>}

                            {isDevOrProfile && <Row className="my-2">
                                <Col xs={3}>
                                    <FormText label={t("name")} id="contactName" isLoading={isLoading} object={user} />
                                </Col>

                                <Col xs={3}>
                                    <FormText label={t("surname")} id="contactSurname" isLoading={isLoading} object={user} />
                                </Col>

                                <Col xs={2}>
                                    <FormText label={t("relationship")} id="contactRelationship" isLoading={isLoading} object={user} />
                                </Col>
                                 
                                
                            </Row>}
                            {isDevOrProfile && <Row className="my-2">
                                <Col xs={3}>
                                    <FormText label={t("mobile")} id="contactMobile" isLoading={isLoading} object={user} />
                                </Col>

                                <Col xs={3}>
                                    <FormText label={t("landline")} id="contactLandline" isLoading={isLoading} object={user} />
                                </Col>

                                <Col xs={2}>
                                    <FormText label={t("email")} id="contactEmail" isLoading={isLoading} object={user} />
                                </Col>
                                
                            </Row>}


                            {isDevOrProfile && <Row className="my-2">
                                <Col xs={2}>
                                    <FormText lines={3} label={t("address")} id="contactAddress" isLoading={isLoading} object={user} />
                                </Col>
                            </Row>}

                            {type == 3 && <hr />}

                            {type == 3 && <Row className="my-2">
                                <Col xs={8}>
                                    <FormSwitch label={t("salary")} id="salaryWinbiz" isLoading={isLoading} object={user} observe={(v) => setSalary(v)} />
                                </Col>
                            </Row>}

                           
                            
                            {type==3 && salary && <Row className="my-2">
                                <Col xs={3}>
                                    <FormAutoComplete service={searchCompany} itemFn={(option) => `${option.name} - ID: ${option.id}`} validated={validated} required label={t("company")} id="salaryCompany" formId="salaryCompanyId" isLoading={isLoading} object={user} />
                                </Col>

                                <Col xs={3}>
                                    <FormText required label={t("salaryWinbizCode")} id="salaryWinbizCode" isLoading={isLoading} object={user} />
                                </Col>

                                <Col xs={2}>
                                    <FormSelect required label={t("currency")} id="salaryCurrencyId" isLoading={isLoading} object={user} items={currencies?.map((x) => ({ id: x.id, name: `${x.shortName} - ${getLocalizedCountryFromCurrency(x)}` }))} itemId="id" itemLabel="name" />

                                </Col>
                            </Row>
                            }


                            {type == 3 && salary &&
                                <Col xs={8}>
                                <br/>
                                    {isLoading ? <Skeleton width={100} /> : t('expenseWithPackages')}
                                    <Container className="border rounded">
                                    <Row className="my-2">
                                        <Col xs={3}>
                                            <FormSwitch label={t("telephoneIT")} id="telephoneIT" isLoading={isLoading} object={user} observe={(v) => setTelephoneIT(v)} />
                                        </Col>

                                        <Col xs={3}>                                                
                                            <FormText formatInitBlur={v => twoDecimalFormatter(v)} keydownFormat="timesheet" required={telephoneIT} disabled={!telephoneIT} label={t("telephoneITDefault")} id="telephoneITDefault" isLoading={isLoading} object={user} />
                                        </Col>

                                        <Col xs={3}>
                                            <FormSwitch label={t("rAllowance")} id="rAllowance" isLoading={isLoading} object={user} />

                                        </Col>

                                        </Row>
                                    </Container>
                                </Col>
                            }
                            
                            {type == 3 && salary &&
                                <Col xs={8}>
                                    <br />
                                    {isLoading ? <Skeleton width={100} /> : t('expenseWithCosts2')}
                                    <Container className="border rounded">
                                        <Row className="my-2"  >
                                            <Col >
                                                {currencies?.map((c, i) => (
                                                    <Col xs={8} key={i}>
                                                        <FormSwitch label={`${t("expenseWithCosts2")} (${c.shortName})`} id={`expenseCosts_${c.id}`} isLoading={isLoading} object={expenseEnabled} />
                                                    </Col>
                                                ))}
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                            }

                            {user?.authenticatorQR &&

                                <Row className="my-2">                                    
                                    <Col xs={3}>
                                        {isLoading ? <Skeleton /> : <Form.Label>{t("authenticatorQRCode")} <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">Google Authenticator</a></Form.Label>}
                                        {isLoading ? <Skeleton height={50} /> : <img src={user?.authenticatorQR} />}
                                    </Col>
                                </Row>
                            }                           
                          
                        </Stack>

                    </div >

                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(UsersEdit);
